
import { Component, Prop, Vue } from "vue-property-decorator";
import ProduceNavVue from "@/components/product/ProductNav.vue";
import { RouterHelper } from "@/router/routerHelper";

@Component({
  components: {
    "product-nav": ProduceNavVue,
  },
})
export default class LiteBeeWingFbVue extends Vue {
  /** 各段高度直接取切图的实际高度（这套切图每段都不一样），加起来 = 设计稿总高 10106 */
  bannerH: number = 750;
  introH: number = 368;

  /** 首屏 banner，切图 1920×750 */
  banner: string = require("@/assets/img/prod/liteBeeWingFb/1.jpg");

  /** 产品简介文字层，切图 1920×368（整段透明底白字） */
  intro: string = require("@/assets/img/prod/liteBeeWingFb/2-text.png");

  /** 特性段，背景图 + 文字层同高叠加；第 10、11 段（产品清单 / 产品规格）整段自带文字，没有单独文字层 */
  sections: Array<any> = [
    {
      id: 3,
      h: 1086,
      bg: require("@/assets/img/prod/liteBeeWingFb/3.jpg"),
      txt: require("@/assets/img/prod/liteBeeWingFb/3-text.png"),
    },
    {
      id: 4,
      h: 1077,
      bg: require("@/assets/img/prod/liteBeeWingFb/4.jpg"),
      txt: require("@/assets/img/prod/liteBeeWingFb/4-text.png"),
    },
    {
      id: 5,
      h: 1081,
      bg: require("@/assets/img/prod/liteBeeWingFb/5.jpg"),
      txt: require("@/assets/img/prod/liteBeeWingFb/5-text.png"),
    },
    {
      id: 6,
      h: 1079,
      bg: require("@/assets/img/prod/liteBeeWingFb/6.jpg"),
      txt: require("@/assets/img/prod/liteBeeWingFb/6-text.png"),
    },
    {
      id: 7,
      h: 1082,
      bg: require("@/assets/img/prod/liteBeeWingFb/7.jpg"),
      txt: require("@/assets/img/prod/liteBeeWingFb/7-text.png"),
    },
    {
      id: 8,
      h: 1080,
      bg: require("@/assets/img/prod/liteBeeWingFb/8.jpg"),
      txt: require("@/assets/img/prod/liteBeeWingFb/8-text.png"),
    },
    {
      id: 9,
      h: 1078,
      bg: require("@/assets/img/prod/liteBeeWingFb/9.jpg"),
      txt: require("@/assets/img/prod/liteBeeWingFb/9-text.png"),
    },
    {
      id: 10,
      h: 1081,
      bg: require("@/assets/img/prod/liteBeeWingFb/10.jpg"),
      txt: "",
    },
    {
      id: 11,
      h: 712,
      bg: require("@/assets/img/prod/liteBeeWingFb/11.jpg"),
      txt: "",
    },
  ];

  tabList: Array<any> = [];

  mounted() {
    new (<any>window).WOW().init();

    RouterHelper.getProdRouterConfig("liteBeeWingFb", (data: Array<any>) => {
      this.tabList = data;
    });
  }
}
